import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  search?: boolean;
}

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ error, search, className, ...rest }, ref) => (
    <div className="flex flex-col gap-s2">
      <input
        ref={ref}
        className={cn(
          'bg-input border rounded-sm px-s4 py-[9px] font-body text-[13.5px] text-fg-1 outline-none transition-all duration-fast ease-soft',
          'placeholder:text-fg-4',
          'hover:border-[var(--border-strong)]',
          'focus:border-moss-400 focus:bg-card focus:shadow-[0_0_0_3px_rgba(149,184,134,0.12)]',
          search && 'pl-[34px] bg-no-repeat bg-[10px_center] bg-[length:16px]',
          error && 'border-petal-500 focus:border-petal-500 focus:shadow-[0_0_0_3px_rgba(185,111,108,0.12)]',
          className,
        )}
        style={
          search
            ? {
                backgroundImage:
                  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%237d8275' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'><circle cx='11' cy='11' r='7'/><path d='m20 20-3.5-3.5'/></svg>\")",
              }
            : undefined
        }
        {...rest}
      />
      {error && <span className="font-body text-[11.5px] text-petal-300">{error}</span>}
    </div>
  ),
);
Input.displayName = 'Input';

export default Input;
